import React from 'react';

interface Props {
	className?: string;
	onClick?: () => void;
}

const CarrotDownSVG: React.FC<Props> = ({ className = '', onClick }) => {
	return (
		<svg className={className} onClick={() => onClick && onClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
			<path
				/* eslint-disable-next-line max-len */
				d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
			/>
		</svg>
	);
};

export default CarrotDownSVG;
